import React, { useRef, useState, useEffect } from "react";
import {
  IonPage,
  IonContent,
  IonButton,
  IonItem,
  IonSelect,
  IonSelectOption,
  IonInput,
  IonTextarea,
  IonSpinner,
  IonLabel,
  IonIcon,
  useIonRouter,
  IonSearchbar,
  IonModal,
} from "@ionic/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { editProfile } from "../../redux/actions/currentProfileActions";
import { newPost } from "../../redux/actions/postActions";
import { DEFAULT_HOME_PATH } from "../../utils/constents";
// import { useTranslation } from "react-i18next";
import canada from "canada";

import "swiper/css";
import "swiper/css/pagination";
import "./Onboarding.css";
import { CanadianButton } from "../../ui-components/CanadianButton";
import UploadAvatarForm from "../../components/form/UploadAvatarForm";
// --- 2. ADD THE LOGIC HERE (Outside the component) ---
const citiesByProvince = {};
canada.cities.forEach(([cityName, provinceCode]) => {
  if (!citiesByProvince[provinceCode]) {
    citiesByProvince[provinceCode] = [];
  }
  citiesByProvince[provinceCode].push(cityName);
});

// Sort them alphabetically once
Object.keys(citiesByProvince).forEach((code) => {
  citiesByProvince[code].sort();
});
const PROVINCES = [
  { code: "AB", name: "Alberta" },
  { code: "BC", name: "British Columbia" },
  { code: "MB", name: "Manitoba" },
  { code: "NB", name: "New Brunswick" },
  { code: "NL", name: "Newfoundland and Labrador" },
  { code: "NS", name: "Nova Scotia" },
  { code: "ON", name: "Ontario" },
  { code: "PE", name: "Prince Edward Island" },
  { code: "QC", name: "Quebec" },
  { code: "SK", name: "Saskatchewan" },
  { code: "NT", name: "Northwest Territories" },
  { code: "NU", name: "Nunavut" },
  { code: "YT", name: "Yukon" },
];

const Onboarding = () => {
  // const history = useHistory();
  const router = useIonRouter();
  const dispatch = useDispatch();
  const swiperRef = useRef(null);
  const textareaRef = useRef(null);
  // const { t } = useTranslation();

  const user = useSelector((state) => state.currentProfile.data);
  const [city, setCity] = useState("");
  const [province, setProvince] = useState("");
  const [introText, setIntroText] = useState("");
  const [loading, setLoading] = useState(false);
  const [filteredCities, setFilteredCities] = useState([]);
  const [searchText, setSearchText] = useState("");
  // Step 3a: When province changes, update the city list and reset current city
  // Replace your old map logic with this filtered version
  const displayCities = filteredCities
    .filter((c) => c.toLowerCase().includes(searchText.toLowerCase()))
    .slice(0, 50); // <--- Only render the first 50 results
  const handleProvinceChange = (e) => {
    const selectedProvince = e.detail.value;
    setProvince(selectedProvince);
    setCity(""); // Reset city to prevent "Toronto, AB" errors
    setSearchText(""); // <--- ADD THIS LINE
    // Get the list of cities for this province from our grouped object
    const cities = citiesByProvince[selectedProvince] || [];
    setFilteredCities(cities);
  };

  // Auto-fill intro text when city/province changes
  useEffect(() => {
    const location =
      city && province ? `${city}, ${province}` : city || province;

    const postText = location
      ? `Hi Canada 🇨🇦👋
I'm from ${location}
`
      : `Hi Canada 🇨🇦👋
`;
    setIntroText(postText);
  }, [city, province]);

  const handleComplete = () => {
    if (user?._id) {
      localStorage.setItem(`onboarding_${user._id}`, "true");
    }
    router.push(DEFAULT_HOME_PATH);
  };

  const handleContinue = async () => {
    // Save location if entered
    if (city || province) {
      setLoading(true);
      const locationString =
        province && city ? `${city}, ${province}` : province ? province : city;
      const payload = { location: locationString, city, province };

      // We only update if we have a valid user
      if (user) {
        dispatch(editProfile(payload));
      }
      setLoading(false);
    }

    // Move to next slide
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  const handlePost = async () => {
    if (!introText) return;
    setLoading(true);

    const formData = new FormData();
    formData.append("body", introText);

    dispatch(newPost(formData)).finally(() => {
      setLoading(false);
      handleComplete();
    });
  };

  const handleSlideChange = (swiper) => {
    if (swiper.activeIndex === 2) {
      setTimeout(() => {
        textareaRef.current?.setFocus();
      }, 500);
    }
  };

  return (
    <IonPage className="swipper">
      <IonContent fullscreen>
        <Swiper
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          allowTouchMove={false}
          className="onboarding-swiper"
          modules={[Pagination]}
          pagination={{ clickable: true }}
          onSlideChange={handleSlideChange}
        >
          {/* Screen 1: Welcome & Location */}
          <SwiperSlide>
            <div className="onboarding-slide-content">
              <h3>Welcome to LoonLog 🇨🇦</h3>
              <p className="onboarding-text">Where in Canada are you from? </p>

              <div className="onboarding-input-container">
                {/* <IonSelect
                  placeholder="Province / Territory"
                  value={province}
                  onIonChange={(e) => setProvince(e.detail.value)}
                  interface="popover"
                  fill="outline"
                >
                  {PROVINCES.map((p) => (
                    <IonSelectOption key={p.code} value={p.code}>
                      {p.name}
                    </IonSelectOption>
                  ))}
                </IonSelect>
                <IonInput
                  placeholder="City"
                  value={city}
                  onIonChange={(e) => setCity(e.detail.value)}
                  fill="outline"
                />
               */}
                {/* 1. Province Selection */}
                <IonSelect
                  placeholder="Province / Territory"
                  value={province}
                  onIonChange={handleProvinceChange} // Use our new handler
                  interface="popover"
                  fill="outline"
                >
                  {PROVINCES.map((p) => (
                    <IonSelectOption key={p.code} value={p.code}>
                      {p.name}
                    </IonSelectOption>
                  ))}
                </IonSelect>

                {/* 2. City Selection - Now dynamic! */}
                {/* <IonSelect
                  placeholder="City"
                  value={city}
                  disabled={!province} // Keep it disabled until province is picked
                  onIonChange={(e) => setCity(e.detail.value)}
                  interface="alert" // Use 'alert' for long lists of cities to allow searching
                  fill="outline"
                  // Add this to make the popup look professional
                  interfaceOptions={{
                    header: "Select your City",
                    subHeader: "Cities available in " + province,
                  }}
                >
                  {filteredCities.map((cityName) => (
                    <IonSelectOption key={cityName} value={cityName}>
                      {cityName}
                    </IonSelectOption>
                  ))}
                </IonSelect> */}
                {/* 2. City Selection - Searchable Modal Style */}
                <IonItem lines="none" className="ion-no-padding">
                  <IonInput
                    placeholder="Search City"
                    value={city}
                    readonly // Makes it act like a button
                    disabled={!province}
                    id="open-city-modal" // This ID triggers the modal below
                    fill="outline"
                    labelPlacement="stacked"
                  />
                </IonItem>
                <IonModal
                  trigger="open-city-modal"
                  initialBreakpoint={0.75}
                  breakpoints={[0, 0.75, 1]}
                >
                  <IonContent className="ion-padding">
                    <div style={{ marginBottom: "10px" }}>
                      <h3>Select City</h3>
                      <IonSearchbar
                        placeholder="Type city name..."
                        onIonInput={(e) => setSearchText(e.detail.value)}
                      />
                    </div>

                    <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      {displayCities.length > 0 ? (
                        displayCities.map((cityName) => (
                          <IonItem
                            button
                            key={cityName}
                            onClick={() => {
                              setCity(cityName);
                              setSearchText("");
                              document.querySelector("ion-modal").dismiss(); // Close modal on select
                            }}
                          >
                            <IonLabel>{cityName}</IonLabel>
                          </IonItem>
                        ))
                      ) : (
                        <IonItem lines="none">
                          <IonLabel color="medium">No cities found</IonLabel>
                        </IonItem>
                      )}
                    </div>
                  </IonContent>
                </IonModal>
              </div>

              <div className="onboarding-button-container">
                <CanadianButton
                  expand="block"
                  className="rounded-button poppins"
                  onClick={handleContinue}
                  shape="round"
                  color="success"
                >
                  {loading ? <IonSpinner name="dots" /> : "Continue"}
                </CanadianButton>
                <IonButton
                  expand="block"
                  className="rounded-button"
                  // fill="outline"
                  // onClick={handleComplete}
                  onClick={handleContinue}
                  shape="round"
                  color="light"
                >
                  Not now
                </IonButton>
              </div>
            </div>
          </SwiperSlide>

          {/* Screen 2: Avatar Upload */}
          <SwiperSlide>
            <div className="onboarding-slide-content">
              <h3>Add a profile photo</h3>
              <p className="onboarding-text">
                Your photo helps Loons trust and connect with you.
              </p>

              <div className="onboarding-input-container">
                <UploadAvatarForm />
              </div>

              <div className="onboarding-button-container">
                <CanadianButton
                  expand="block"
                  className="rounded-button poppins"
                  onClick={() => swiperRef.current?.slideNext()}
                  shape="round"
                  color="success"
                >
                  Continue
                </CanadianButton>
                <IonButton
                  expand="block"
                  className="rounded-button"
                  onClick={() => swiperRef.current?.slideNext()}
                  shape="round"
                  color="light"
                >
                  Not now
                </IonButton>
              </div>
            </div>
          </SwiperSlide>

          {/* Screen 2: Introduce Yourself */}
          <SwiperSlide>
            <div className="onboarding-slide-content">
              <h3>Welcome to LoonLog 🇨🇦</h3>
              <p className="onboarding-text">
                Help us kickstart the community with a quick first post
              </p>

              <div className="onboarding-input-container">
                <IonTextarea
                  rows={4}
                  placeholder="Share something..."
                  value={introText}
                  onIonChange={(e) => setIntroText(e.detail.value)}
                  fill="outline"
                  ref={textareaRef}
                />
              </div>

              <div className="onboarding-button-container">
                <CanadianButton
                  expand="block"
                  className="rounded-button poppins"
                  onClick={handlePost}
                  shape="round"
                  disabled={loading}
                >
                  {loading ? <IonSpinner name="dots" /> : "Post"}
                </CanadianButton>
                <IonButton
                  expand="block"
                  className="rounded-button"
                  // fill="outline"
                  onClick={handleComplete}
                  shape="round"
                  color="light"
                >
                  Not now
                </IonButton>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </IonContent>
    </IonPage>
  );
};

export default Onboarding;
